import { UIGameResponsiveController } from '../../../shared/scripts/ui_game/UIGameResponsiveController.ts';
export class UIMGameResponsiveController extends UIGameResponsiveController {
    // eslint-disable-next-line class-methods-use-this
    showVerticalAds() {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    showHorizontalAds() {
        return false;
    }
    getScaleForRotation() {
        return window.innerWidth / this.uiGameManager.canvasController.appW;
    }
    // eslint-disable-next-line class-methods-use-this
    getAppWnH() {
        const w = window.innerWidth;
        const h = UIMGameResponsiveController.getWindowHeightWithIOS26Fix();
        return {
            w: w,
            h: h
        };
    }
    // Since iOS 26, window.innerHeight does not always reflect the actual height of the window when the window.resize event is triggered.
    // This function is a workaround because body.clientHeight is somehow always correct
    static getWindowHeightWithIOS26Fix() {
        return document.body.clientHeight;
    }
    // eslint-disable-next-line class-methods-use-this
    getCanvasY() {
        return 0;
    }
    // eslint-disable-next-line class-methods-use-this
    getCanvasX() {
        return 0;
    }
    buildRenderer() {
        const size = this.getAppWnH();
        this.uiGameManager.canvasController.app.renderer.resize(size.w, size.h);
        this.uiGameManager.canvasController.app.view.style.top = '0%';
    }
    constructor(uiGameManager){
        super(uiGameManager);
        UIGameResponsiveController.resolutionScale = 2;
    }
}
